const promotionElement = document.querySelector("[data-js='promotion']");

class Promotion {
  constructor(element) {
    this.element = element;

    this.selectInput = this.element.querySelector(".js-promotion-id-value");
    this.idInput = this.element.querySelector(".js-promotion-id-input");

    this.initialize();
  }

  initialize() {
    this.selectInput.addEventListener("change", (e) => {
      this.idInput.value = e.target.value;
    });
  }
}

if (promotionElement) {
  new Promotion(promotionElement);
}
